import React, { useState, useEffect } from 'react'
import swal from 'sweetalert';
import '../../material.css'
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars'
import Select from 'react-select';
import axios from 'axios';

export default function Addshift(props) {
    //const [timein, settimein] = useState("");
    //const [timeout, settimeout] = useState("");
   // const [items, setitems] = useState({ ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", type: "", daystype: "", UnitId: "", Amount: "", company_id: props.companyid })
   // const [items, setitems] = useState({ ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", type: "", company_id: props.companyid })
    const [items, setitems] = useState({ ShiftName: "", desciption: "", type: "",  company_id: props.companyid })
    const [typevalue, settypevalue] = useState()
    const [typevaluecom, settypevaluecom] = useState();
    const [typecom, settypecom] = useState([])
    const [addunit, setunit] = useState([])
    const [unitvalue, setunitvalue] = useState()
    const [type, settype] = useState([
        { label: "Morning 12 hours", value: "1" },
        { label: "Night 12 Hours", value: "2" },
        { label: "Morning 24 hours", value: "3" },
        { label: "Night 24 Hours", value: "4" }

    ])
    const [daystypevalue, setdaystypevalue] = useState()
    const [daystype, setdaystype] = useState([
        { label: "Weekdays", value: "1" },
        { label: "Weekends", value: "2" }
    ])
    useEffect(() => {
        fetchCompany()
    }, []);
    async function fetchCompany() {

        var res = await axios.get(process.env.REACT_APP_APIURL + "Company/GetCompanies")

        var type = [];
        res.data.map((u) => {
            type.push({ value: u.company_id, label: u.name });
        })
        settypecom(type)
    }
    async function fetchUnitdata() {
        const Uniturl = process.env.REACT_APP_APIURL + "FramUnit/GetFramUnits?companyid=" + props.companyid;
        let Unitdata = await axios.get(Uniturl);
        var units = [];
        Unitdata.data.map((u) => {
            units.push({ value: u.unitId, label: u.unitName });
        })
        setunit(units);
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    //const handletime = e => {
    //    if (e.value) {
    //        const name = e.target.name;
    //        setitems({ ...items, [name]: e.value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) })
    //    }
    //}
    const refresh = () => {
        //setitems({ ...items, ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", Amount: "", company_id: props.companyid });
      //  setitems({ ...items, ShiftName: "", Slot: "", CheckInTime: "", CheckOutTime: "", company_id: props.companyid });
        setitems({ ...items, ShiftName: "", desciption: "", company_id: props.companyid });
        settypevaluecom(null)
       // settypevalue(null)
     //   setdaystypevalue(null)
    }
    const savemethod = async (data) => {
        debugger;
        data.companyid = typevaluecom.value;
        data.company_id = typevaluecom.value;
        const url = process.env.REACT_APP_APIURL + "Shift/AddShift";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        //if (items.CheckInTime == "") {
        //    swal({
        //        title: "CheckInTime Required!",
        //        icon: "error"
        //    })
        //    return;
        //}
        //if (items.CheckOutTime == "") {
        //    swal({
        //        title: "CheckOutTime Required!",
        //        icon: "error"
        //    })
        //    return;
        //}
        //if (items.type == "") {
        //    swal({
        //        title: "Type Required!",
        //        icon: "error"
        //    })
        //    return;
        //}
        savemethod(items);
        // console.log(items);
    }
    return (
        <div className="row">
            <div className="col-12 col-lg-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-2 mt-5 text-center mx-auto">Add Shifts</h3>
                    </div>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row flex-column align-items-center">
                                <div className="mb-3 col-6">
                                    <label htmlFor="shift_name" className="form-label">Shift Name</label>
                                    <input type="text" className="form-control" name="ShiftName" value={items.ShiftName} onChange={handleInput} required />
                                </div>
                                <div className="mb-3 col-6">
                                    <label htmlFor="shift_name" className="form-label">Desciption</label>
                                    <input type="text" className="form-control" name="desciption" value={items.desciption} onChange={handleInput} required />
                                </div>
                                <div className="mb-3 col-sm-6">
                                    <label className="form-label">Comapany Name *</label>
                                    <Select options={typecom} value={typevaluecom} onChange={(e) => { settypevaluecom(e); setitems({ ...items, usertypeid: e.value }) }} />
                                </div>
                                <div className="mb-3 col-sm-6">
                                    <label htmlFor="timepicker2">Type</label>
                                    <Select value={typevalue} options={type} onChange={(e) => { settypevalue(e); setitems({ ...items, type: e.value }) }} />
                                </div>
                                {/*<div className="mb-3 col-6">*/}
                                {/*    <label htmlFor="shift_name" className="form-label">Slot</label>*/}
                                {/*    <input type="text" className="form-control" name="Slot" value={items.Slot} onChange={handleInput} />*/}
                                {/*</div>*/}
                                {/*<div className="mb-3 col-sm-6">*/}
                                {/*    <label htmlFor="timepicker">CheckIn Time</label>*/}
                                {/*    <TimePickerComponent name="CheckInTime" className="form-control" value={items.CheckInTime} onChange={handletime}  />*/}
                                {/*</div>*/}
                                {/*<div className="mb-3 col-sm-6">*/}
                                {/*    <label htmlFor="timepicker2">CheckOut Time</label>*/}
                                {/*    <TimePickerComponent name="CheckOutTime" className="form-control" value={items.CheckOutTime} onChange={handletime}  />*/}
                                {/*</div>*/}
                                {/*<div className="mb-3 col-sm-6 viz">*/}
                                {/*    <label htmlFor="unit_name" className="form-label">Unit</label>*/}
                                {/*    <Select name="unit" autoComplete="off" value={unitvalue} options={addunit} onChange={(e) => { setunitvalue(e); setitems({ ...items, UnitId: e.value }) }} />*/}
                                {/*</div>*/}
                                {/*<div className="mb-3 col-6">*/}
                                {/*    <label htmlFor="amount_name" className="form-label">Amount</label>*/}
                                {/*    <input type="text" className="form-control" name="Amount" value={items.Amount} onChange={handleInput} required />*/}
                                {/*</div>*/}
                               
                                {/*<div className="mb-3 col-sm-6">*/}
                                {/*    <label htmlFor="timepicker2">Day</label>*/}
                                {/*    <Select value={daystypevalue} options={daystype} onChange={(e) => { setdaystypevalue(e); setitems({ ...items, daystype: e.value }) }} />*/}
                                {/*</div>*/}
                                <div> 
                                    <button type="submit" className="btn btn-primary">Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}